import { render, staticRenderFns } from "./Office.vue?vue&type=template&id=7900af3f&scoped=true&lang=html&"
import script from "./Office.vue?vue&type=script&lang=js&"
export * from "./Office.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7900af3f",
  null
  
)

export default component.exports